import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { QuestionnaireRespondentSessionCreateInput } from '../generated/globalTypes';
import { createQuestionnaireRespondentSessionMutation, createQuestionnaireRespondentSessionMutationVariables } from '../generated/createQuestionnaireRespondentSessionMutation';
import { questionnaireRespondentSessionFieldsFragment } from '../models/QuestionnaireRespondentSession';

/**
 * Get a callback to create a QuestionnaireRespondentSession in the store.
 */
export function useCreateQuestionnaireRespondentSessionCallback(): [(model: QuestionnaireRespondentSessionCreateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<createQuestionnaireRespondentSessionMutation, createQuestionnaireRespondentSessionMutationVariables>(
        gql`
            mutation createQuestionnaireRespondentSessionMutation ($model: QuestionnaireRespondentSessionCreateInput!) {
                createQuestionnaireRespondentSession(model: $model) {
                    ...questionnaireRespondentSessionFields
                }
            }

            ${questionnaireRespondentSessionFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (model: QuestionnaireRespondentSessionCreateInput) => {
        const result = await mutationAction({ variables: { model: model } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
